import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PROJECT_UPDATE',
    smsDelete : 'PROJECT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        label: [],
        lead: [],
        lead_activities: [],
        lead_stats:{},
        lead_details: null,
        lead_count:null,
        projectLoading: false,
        projectError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,
        lead_notes:[],
        lead_next_actions:[],
        lead_attchments:[],
        all_lead_activities:[],

        ...store
    },
    mutations : {
        ...mutations,
        SET_LABEL (state, label) {
            state.label = label;
        },
        SET_LEAD (state, {results,pg_count}) {
            state.lead = results;
            state.lead_count = pg_count;
        },
        SET_LEAD_STATS (state, stats) {
            state.lead_stats = stats;
        },
        SET_LEAD_DETAILS (state, details) {
            state.lead_details = details;
        },
        SET_LEAD_ACTIVITIES (state, activities) {
            state.lead_activities = activities;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },
        SET_LEAD_NOTES (state, lead_notes) {
            state.lead_notes = lead_notes;
        },
        SET_LEAD_NEXT_ACTIONS(state, lead_next_actions) {
            state.lead_next_actions = lead_next_actions;
        },
        SET_LEAD_ATTACHMENTS(state, lead_attchments) {
            state.lead_attchments = lead_attchments;
        },
        SET_ALL_LEAD_ACTIVITIES(state, details) {
            state.all_lead_activities = details;
        },
    },

    actions: {
        async updateLead ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.patch(V1API.edit_lead + payload.item.id, payload.item, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label,stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
            return response
        },

        async deleteLead ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_lead + payload.item, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label, stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
            
            return response
        },

        async fetchLead ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.contacted) params.append('contacted', payload.contacted);
                if (payload.label) params.append('label', payload.label);
                if (payload.stage) params.append('stage', payload.stage);
                if (payload.status) params.append('status', payload.status);
                if (payload.owner) params.append('owner', payload.owner);
                if (payload.source) params.append('source', payload.source);
                if (payload.closure_status) params.append('closure_status', payload.closure_status);
               
           
                let url = V1API.get_lead + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data

                commit('SET_LEAD', {results, pg_count});
                return result
              

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
           
        },

        async fetchLeadStats ({ commit }) {
          

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_lead_stats, config);
                let response = result.data

                commit('SET_LEAD_STATS', response.data);

            } catch(error) {
              
            }
            finally {
               
            }
           
        },


        async fetchLeadDetails ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_lead_details + payload, config);
                let response = result.data

                commit('SET_LEAD_DETAILS', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        async addLead ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_lead, payload.item, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label,stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addLeadActivity ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.add_lead_activity + payload.leadId + '/activity/create/', payload.activity, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('viewLeadActivityByType', {leadId: payload.leadId, activityType: payload.activity.type})
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        // Lead Notes

        async addLeadNote ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_lead_note + payload.lead_id + '/note/create/', payload.lead_note, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLeadNotes', payload.lead_id)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async updateLeadNote ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.patch(V1API.edit_lead_note + payload.lead_note?.id + '/edit/', payload.lead_note, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLeadNotes', payload.lead_id)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async deleteNote ({commit, dispatch}, payload) {
         
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.delete(V1API.delete_lead_note + payload.note_id + '/delete/', config).then(result=>{
                    let data = result.data
                    return data

                });
                dispatch ('fetchLeadNotes', payload.lead_id)
                return response

            }catch (e) {
               
            }finally {
               
            }
        },

        async fetchLeadNotes ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.lead_notes + payload + '/note/', config);
                let response = result.data

                commit('SET_LEAD_NOTES', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        // Lead Next Actions
        
        async addLeadAction ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_lead_next_action + payload.lead_id + '/action/create/', payload.lead_action, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLeadNextActions', payload.lead_id)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async updateLeadNextAction ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.patch(V1API.edit_next_action + payload.lead_action?.id + '/edit/', payload.lead_action, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLeadNextActions', payload.lead_id)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async deleteNextAction ({commit, dispatch}, payload) {
         
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.delete(V1API.delete_next_action + payload.action_id + '/delete/', config).then(result=>{
                    let data = result.data
                    return data

                });
                dispatch ('fetchLeadNextActions', payload.lead_id)
                return response

            }catch (e) {
               
            }finally {
               
            }
        },

        async fetchLeadNextActions ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.lead_next_actions + payload + '/action/', config);
                let response = result.data

                commit('SET_LEAD_NEXT_ACTIONS', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        // Get all lead activities
        async viewLeadActivities ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_all_lead_activity, config);
                let response = result.data

                commit('SET_ALL_LEAD_ACTIVITIES', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },



        async viewLeadActivityByType ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.view_lead_activity + payload.leadId + '/activity/?type=' + payload.activityType, config);
                let response = result.data

                commit('SET_LEAD_ACTIVITIES', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addLabel ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_label, {
                    name: payload
                }, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchLabel')
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        
        async updateLeadStatus({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.lead_update_info+ payload.id + "/status/" , {
                    status :  payload.status_for_change
                }, config).then(result => {
                    let data = result.data
                    return data
                })
                if(payload.from_details ){
                    dispatch('fetchLeadDetails', payload.id)
                }else{
                     dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label,stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
                }
               
                return response

            } catch (e) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async updateLeadHealthStatus({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.lead_health_status_update+ payload.lead_id + "/health/" , {
                    [payload.type]: payload.status
                }, config).then(result => {
                    let data = result.data
                    return data
                })
                
                dispatch ('fetchLeadDetails',payload.lead_id)
                
               
                return response

            } catch (e) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        // Lead Attachment
        async addLeadAttachment ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };
            try{
                let data= new FormData()
                let payloadData = buildFormData(data, payload.attachment);
        
                let response = await axios.post(V1API.add_file_lead + payload.lead_id + '/file/upload/', payloadData, config).then(result=>{
                  
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch("fetchLeadAttachments",payload.lead_id)
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async deleteAttachmentLead ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_lead_file + payload.attachment + '/delete/', config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchLeadAttachments',payload.lead_id)
            
            return response
        },

        
        async fetchLeadAttachments ({ commit },payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.lead_file_list + payload + '/file/', config);
                let response = result.data

                commit('SET_LEAD_ATTACHMENTS', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },


        async updateLeadStage({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.lead_update_info+ payload.id + "/stage/" , {
                    stage :  payload.stage
                }, config).then(result => {
                    let data = result.data
                    return data
                })
                dispatch ('fetchLeadDetails',payload.id)
                return response

            } catch (e) {
                commit('TICKET_ERROR', true);
            } finally {
                commit('TICKET_LOADING', false);
            }
        },

        async fetchLabel ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_label, config);
                let response = result.data

                commit('SET_LABEL', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async addLabeltoLead ({ commit, dispatch }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.post(V1API.add_label_to_lead + payload.lead, {
                    label_id: payload.label_id
                }, config)

                let response = result.data

                if(payload.labelAdd_delete){
                    dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label,stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
                }
               
               // dispatch ('fetchLabel')

                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
            
        },

        async deleteLabelfromLead ({ commit, dispatch }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.post(V1API.delete_label_from_lead + payload.leadId, {
                    label_id: payload.label_id
                }, config)

                let response = result.data

                if(payload.labelAdd_delete){
                    dispatch ('fetchLead',{perPage:payload.perPage,currentPage:payload.page,search_term:payload.search_term,contacted:payload.contacted,label:payload.label,stage: payload.stage, status: payload.status, owner: payload.owner, source: payload.source, closure_status: payload.closure_status})
                }
                // dispatch ('fetchLabel')

                return response

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            }
            finally {
                commit('SUBMIT_LOADING', false);
            }
           
        },

        async deleteLabel ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_label + payload, config).then(result=>{
                let data = result.data
                return data
            })
            
            // dispatch ('fetchLead')
            dispatch ('fetchLabel')
            
            return response
        }
    },

    getters: {}
}
